import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { TextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { ButtonModule, RadioButtonModule } from '@syncfusion/ej2-angular-buttons';
import { DropDownListModule, MultiSelectModule, CheckBoxSelectionService } from '@syncfusion/ej2-angular-dropdowns';
import { DatePickerModule, DateTimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { GridAllModule } from '@syncfusion/ej2-angular-grids';
import { TabModule } from '@syncfusion/ej2-angular-navigations';
import { AccordionModule } from '@syncfusion/ej2-angular-navigations';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { ToastModule } from '@syncfusion/ej2-angular-notifications';
import { RichTextEditorModule } from '@syncfusion/ej2-angular-richtexteditor';
import { PageService, SortService, FilterService, GroupService, FreezeService, EditService, ForeignKeyService, SelectionService  } from '@syncfusion/ej2-angular-grids';
//import { RichTextEditorAllModule } from '@syncfusion/ej2-angular-richtexteditor';
import { ResizeService ,ToolbarService, ExcelExportService } from '@syncfusion/ej2-angular-grids';
import { CheckBoxModule } from '@syncfusion/ej2-angular-buttons';
import { UploaderModule } from '@syncfusion/ej2-angular-inputs';
import { AutoCompleteModule } from '@syncfusion/ej2-angular-dropdowns';
import { ChartModule, AccumulationChartModule } from '@syncfusion/ej2-angular-charts';
import { NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { ClickStopPropagation } from './helpers/stopclick.directive';
import { HelperService } from './services/helper.service';
import { AuthenService } from './services/authen.service';
import { AuthInterceptor } from './services/auth-interceptor.service';
import { SidebarService } from './sidebar/sidebar.service';
import { NgxLoadingModule } from 'ngx-loading';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { SidebarComponent } from './sidebar/sidebar';
import { MenuBarComponent } from './menu-bar/menu-bar';

import { HomeComponent } from './pages/home/home.component';
import { RequestsAllComponent } from './pages/requests-all/requests-all';
import { RequestsSCReturnComponent } from './pages/requests-all/requests-sc-return';
import { RequestsCheckingComponent } from './pages/requests-all/requests-checking';
import { RequestsInProgressComponent } from './pages/requests-all/requests-inprogress';
import { RequestsReturnedComponent } from './pages/requests-all/requests-returned';
import { RequestsPendingComponent } from './pages/requests-all/requests-pending';
import { RequestsCancelComponent } from './pages/requests-all/requests-cancel';
import { RequestsFinishedComponent } from './pages/requests-all/requests-finished';
import { RequestsFFMWaitComponent } from './pages/requests-all/requests-ffm-wait'; 
import { RequestsFFMApproveComponent } from './pages/requests-all/requests-ffm-approve'; 
import { RequestsSCOpeningComponent } from './pages/requests-all/requests-sc-opening'; 
import { RequestsSCFinishedComponent } from './pages/requests-all/requests-sc-finished';
import { RequestsSCCancelComponent } from './pages/requests-all/requests-sc-cancel';
import { RequestsSCPendingComponent } from './pages/requests-all/requests-sc-pending';

import { RequestPropComponent } from './pages/request-prop/request-prop';
import { RequestNewComponent } from './pages/request-prop/request-new';
import { DetailTabComponent } from './pages/request-prop/detail-tab/detail-tab';
import { InformationsTabComponent } from './pages/request-prop/informations-tab/informations-tab';
import { AttachedFilesComponent } from './controls/attached-files/attached-files';
import { ContractFilesComponent } from './controls/contract-files/contract-files';
import { UploadFilesComponent } from "./controls/upload-files/upload-files";
import { PrincipalDetailComponent } from "./pages/principal-detail/principal-detail";
import { PrincipalComponent } from "./pages/principal/principal";
import { PrincipalUserDetailComponent } from "./pages/principal-user-detail/principal-user-detail";
import { PrincipalUserComponent } from "./pages/principal-user/principal-user";
import { AccordionComponent } from "./controls/accordion/accordion";
import { ReportComponent } from './pages/report/report.component';
import { ReportItemComponent } from './pages/report-by-item/report.item.component';
import { ReportQuota } from './pages/report-quota/report.quota';
import { ReportQuotaPhasingMonthly } from './pages/report-quota-phasing-monthly/report.quota.phasing.monthly';
import { ReportDocumentComponent } from './pages/report-document/report.document';
import { ReportVisaComponent } from './pages/report-visa/report.visa';
import { ReportMonitorTimelineComponent } from './pages/report-monitor-timeline/report.monitor.timeline';
import { ReportRequestDetailComponent } from "./pages/report-request-detail/report-request-detail";
import { ReportSummaryRequestComponent } from "./pages/report-summary-request/report-summary-request";
import { ReportSummaryRequestStatusComponent } from "./pages/report-summary-request-status/report-summary-request-status";
import { UserRoleOnMenuComponent } from './pages/user-role-on-menu/user-role-on-menu';
import { UserRoleOnPrincipalComponent } from "./pages/user-role-on-principal/user-role-on-principal";
import { AutoCompleteComponent } from '@syncfusion/ej2-angular-dropdowns';

import { UploadFileDialogComponent } from "./dialogs/upload-file-dialog/upload-file-dialog";
import { ImportFileDialogComponent } from "./dialogs/import-file-dialog/import-file-dialog";
import { MyImportFileDialogComponent } from "./dialogs/my-import-file-dialog/my-import-file-dialog";
import { RequestMailDialogComponent } from "./dialogs/request-mail-dialog/request-mail-dialog";
import { ChangePwdDialogComponent } from "./dialogs/change-pwd-dialog/change-pwd-dialog";

import { UserSecurityTenderComponent } from "./pages/user-security-tender/user-security-tender";
import { DashboardComponent } from "./pages/dashboard/dashboard";
import { AutoCompleteCustomerComponent } from "./controls/autocomplete-customer/autocomplete-customer";

import { CustomerMasterPageComponent } from "./pages/customer-master-page/customer-master-page";
import { CustomerMasterPropComponent } from "./pages/customer-master-prop/customer-master-prop";
import { CustomerMasterEditComponent } from "./pages/customer-master-edit/customer-master-edit";
import { HSMatrixPageComponent } from "./pages/hs-matrix-page/hs-matrix-page";
import { HSMatrixEditComponent } from "./pages/hs-matrix-edit/hs-matrix-edit";
import { FFMMatrixPageComponent } from "./pages/ffm-matrix-page/ffm-matrix-page";
import { FFMMatrixEditComponent } from "./pages/ffm-matrix-edit/ffm-matrix-edit";
import { SCMatrixPageComponent } from "./pages/sc-matrix-page/sc-matrix-page";
import { SCMatrixEditComponent } from "./pages/sc-matrix-edit/sc-matrix-edit";
import { ContractAllComponent } from "./pages/contract-all/contract-all";
import { InternalMatrixPageComponent } from "./pages/internal-matrix-page/internal-matrix-page";
import { InternalMatrixEditComponent } from "./pages/internal-matrix-edit/internal-matrix-edit";
import { DetailTabHSComponent } from "./pages/request-prop/detail-tab-hs/detail-tab-hs";

import {
    CategoryService, DateTimeService, ScrollBarService, DataLabelService,
    ColumnSeriesService, LineSeriesService, ChartAnnotationService
    , RangeColumnSeriesService, StackingColumnSeriesService, LegendService, TooltipService, BarSeriesService,
    PieSeriesService, AccumulationLegendService, AccumulationTooltipService, AccumulationAnnotationService,
    AccumulationDataLabelService
}
    from '@syncfusion/ej2-angular-charts';
import { TreeViewModule } from '@syncfusion/ej2-angular-navigations';
import { SignalRService } from './services/signalRService';
import { SnowFallComponent } from "./pages/snow-fall/snow-fall";
import { RequestInternalComponent } from "./pages/request-internal/request-internal";

import { HSMatrixV2SearchComponent } from "./pages/hs-matrix-v2/hs-matrix-v2-search";
import { HSMatrixV2DetailComponent } from "./pages/hs-matrix-v2/hs-matrix-v2-detail";

import { BCMatrixV2DetailComponent } from "./pages/bc-matrix-v2/bc-matrix-v2-detail";
import { BCMatrixV2SearchComponent } from "./pages/bc-matrix-v2/bc-matrix-v2-search";

import { FFMMatrixV2SearchComponent } from "./pages/ffm-matrix-v2/ffm-matrix-v2-search";
import { FFMMatrixV2DetailComponent } from "./pages/ffm-matrix-v2/ffm-matrix-v2-detail";
import { RequestSearchV2Component } from "./pages/request-search-v2/request-search-v2";
import { GroupHSCustDetailComponent } from "./pages/group-hs-cust/group-hs-cust-detail";
import { GroupHSCustSearchComponent } from "./pages/group-hs-cust/group-hs-cust-search";
import { GroupHSMemberDetailComponent } from "./pages/group-hs-member/group-hs-member-detail";
import { GroupHSMemberSearchComponent } from "./pages/group-hs-member/group-hs-member-search";
import { RequestSearchCheckinComponent } from "./pages/request-search-v2/request-search-checkin/request-search-checkin";
import { RequestSearchInprogressComponent } from "./pages/request-search-v2/request-search-inprogress/request-search-inprogress";
import { RequestSearchReturnComponent } from "./pages/request-search-v2/request-search-return/request-search-return";
import { RequestSearchOpenComponent } from "./pages/request-search-v2/request-search-open/request-search-open";
import { RequestSearchWaitingFFMComponent } from "./pages/request-search-v2/request-search-waiting-ffm/request-search-waiting-ffm";
import { RequestSearchFinishComponent } from "./pages/request-search-v2/request-search-finish/request-search-finish";
import { RequestSearchCancelComponent } from "./pages/request-search-v2/request-search-cancel/request-search-cancel";
import { RequestSearchPenddingComponent } from "./pages/request-search-v2/request-search-pendding/request-search-pendding";
import { RequestSearchAllComponent } from "./pages/request-search-v2/request-search-all/request-search-all";
import { RequestSearchFFMApprovedComponent } from "./pages/request-search-v2/request-search-ffm-approved/request-search-ffm-approved";
import { HospitalProfileSearchComponent } from "./pages/hospital-profile-search/hospital-profile-search";
import { HospitalProfileDetailComponent } from "./pages/hospital-profile-detail/hospital-profile-detail";
import { AdminSQLComponent } from "./pages/admin-sql/admin-sql";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: true
};

@NgModule({
    declarations: [
        ClickStopPropagation,
        AccordionComponent,

        AppComponent, 
        LoginComponent,
        SidebarComponent,
        MenuBarComponent,
        HomeComponent,
        RequestsAllComponent,
        RequestsSCReturnComponent,
        RequestsCheckingComponent,
        RequestsInProgressComponent,
        RequestsReturnedComponent,
        RequestsPendingComponent,
        RequestsCancelComponent,
        RequestsFinishedComponent,
        RequestsFFMWaitComponent,
        RequestsFFMApproveComponent,
        RequestsSCOpeningComponent,
        RequestsSCFinishedComponent,
        RequestsSCCancelComponent,
        RequestsSCPendingComponent,        
        DetailTabComponent,
        RequestPropComponent,
        RequestNewComponent,                
        InformationsTabComponent,                
        AttachedFilesComponent,
        ContractFilesComponent,
        UploadFilesComponent,                
        PrincipalDetailComponent,
        PrincipalComponent,
        ReportComponent,
        ReportItemComponent,
        ReportQuota,
        ReportQuotaPhasingMonthly,
        ReportDocumentComponent,
        ReportVisaComponent,
        ReportMonitorTimelineComponent,        
        PrincipalUserDetailComponent,
        PrincipalUserComponent,       
        UserRoleOnPrincipalComponent,
        UploadFileDialogComponent,
        ImportFileDialogComponent,
        MyImportFileDialogComponent,                        
        RequestMailDialogComponent,
        ChangePwdDialogComponent,

        UserSecurityTenderComponent,                       
        UserRoleOnMenuComponent,
        DashboardComponent,        
        AutoCompleteCustomerComponent,                
        CustomerMasterPageComponent,
        CustomerMasterPropComponent,
        CustomerMasterEditComponent,
        HSMatrixPageComponent,
        HSMatrixEditComponent,
        ReportRequestDetailComponent,
        ReportSummaryRequestComponent,
        ReportSummaryRequestStatusComponent,
        FFMMatrixPageComponent,
        FFMMatrixEditComponent,
        SCMatrixPageComponent,
        SCMatrixEditComponent,
        ContractAllComponent,
        InternalMatrixPageComponent,
        InternalMatrixEditComponent,
        SnowFallComponent,
        DetailTabHSComponent,
        RequestInternalComponent,

        HSMatrixV2DetailComponent,
        HSMatrixV2SearchComponent,

        BCMatrixV2DetailComponent,
        BCMatrixV2SearchComponent,

        FFMMatrixV2DetailComponent,
        FFMMatrixV2SearchComponent,
        RequestSearchV2Component,
        GroupHSCustDetailComponent,
        GroupHSCustSearchComponent,

        GroupHSMemberDetailComponent,
        GroupHSMemberSearchComponent,
        RequestSearchCheckinComponent,
        RequestSearchInprogressComponent,
        RequestSearchReturnComponent,
        RequestSearchOpenComponent,
        RequestSearchWaitingFFMComponent,
        RequestSearchFinishComponent,
        RequestSearchCancelComponent,
        RequestSearchPenddingComponent,
        RequestSearchAllComponent,
        RequestSearchFFMApprovedComponent,
        HospitalProfileSearchComponent,
        HospitalProfileDetailComponent,
        AdminSQLComponent
    ],
    imports: [
        BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
        BrowserAnimationsModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        TabModule,
        AccordionModule,
        TextBoxModule,
        ButtonModule,
        RadioButtonModule,
        GridAllModule,
        DropDownListModule,
        MultiSelectModule,
        DatePickerModule,
        DateTimePickerModule,
        DialogModule,
        ToastModule,
        RichTextEditorModule,
        PerfectScrollbarModule,        
        MultiSelectModule,
        CheckBoxModule,
        UploaderModule,
        AutoCompleteModule,
        TreeViewModule,
        ChartModule,
        AccumulationChartModule,
        NumericTextBoxModule,
        NgxLoadingModule.forRoot({}),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        RouterModule.forRoot([
            { path: '', component: DashboardComponent, pathMatch: 'full' },            
            //{ path: '', component: TendersAllComponent, pathMatch: 'full' },
            //{ path: '', component: HomeComponent, pathMatch: 'full' },
            { path: 'app-home', component: HomeComponent },
            { path: 'requests-all', component: RequestsAllComponent, runGuardsAndResolvers: 'always' },
           

            { path: 'request-internal', component: RequestInternalComponent, runGuardsAndResolvers: 'always' },
            { path: 'request-internal', component: RequestInternalComponent, runGuardsAndResolvers: 'always' },



            { path: 'requests-sc-return', component: RequestsSCReturnComponent },
            { path: 'requests-checking', component: RequestsCheckingComponent, },
            { path: 'requests-inprogress', component: RequestsInProgressComponent, },
            { path: 'requests-returned', component: RequestsReturnedComponent, },
            { path: 'requests-pending', component: RequestsPendingComponent, },
            { path: 'requests-cancel', component: RequestsCancelComponent, },
            { path: 'requests-finished', component: RequestsFinishedComponent, }, 
            { path: 'requests-ffm-wait', component: RequestsFFMWaitComponent, }, 
            { path: 'requests-ffm-approve', component: RequestsFFMApproveComponent, }, 
            { path: 'requests-sc-opening', component: RequestsSCOpeningComponent, },
            { path: 'requests-sc-finished', component: RequestsSCFinishedComponent },
            { path: 'requests-sc-cancel', component: RequestsSCCancelComponent },
            { path: 'requests-sc-pending', component: RequestsSCPendingComponent },
            { path: 'request-prop/:id/:requestCode/:edit/:requestSrc/:pathCode', component: RequestPropComponent },
            { path: 'request-new', component: RequestNewComponent },            
                                
            { path: 'principal-detail/:id', component: PrincipalDetailComponent },
            { path: 'principal-detail', component: PrincipalDetailComponent },
            { path: 'report', component: ReportComponent },
            { path: 'report-by-item', component: ReportItemComponent },
            { path: 'report-quota', component: ReportQuota },
            { path: 'report-quota-phasing-monthly', component: ReportQuotaPhasingMonthly },            
            { path: 'report-document', component: ReportDocumentComponent },
            { path: 'report-visa', component: ReportVisaComponent },
            { path: 'report-monitor-timeline', component:ReportMonitorTimelineComponent },
            { path: 'report-request-detail', component: ReportRequestDetailComponent },
            { path: 'report-summary-request', component: ReportSummaryRequestComponent },
            { path: 'report-summary-request-status', component: ReportSummaryRequestStatusComponent },
            { path: 'principal', component: PrincipalComponent },
            { path: 'principal-user-detail', component: PrincipalUserDetailComponent },
            { path: 'principal-user-detail/:id', component: PrincipalUserDetailComponent },
            { path: 'principal-user', component: PrincipalUserComponent },            
            { path: 'user-role-on-principal', component: UserRoleOnPrincipalComponent },
            { path: 'user-security-tender', component: UserSecurityTenderComponent },            
            { path: 'user-role-on-menu', component: UserRoleOnMenuComponent },
            { path: 'dashboard', component: DashboardComponent },            
            { path: 'customer-master-page', component: CustomerMasterPageComponent },
            { path: 'customer-master-prop/:id', component: CustomerMasterPropComponent },
            { path: 'customer-master-edit/:id', component: CustomerMasterEditComponent },
            { path: 'hs-matrix-page', component: HSMatrixPageComponent },
            { path: 'hs-matrix-edit/:id', component: HSMatrixEditComponent },
            { path: 'ffm-matrix-page', component: FFMMatrixPageComponent },
            { path: 'ffm-matrix-edit/:id', component: FFMMatrixEditComponent },
            { path: 'sc-matrix-page', component: SCMatrixPageComponent },
            { path: 'sc-matrix-edit/:id', component: SCMatrixEditComponent },
            { path: 'contract-all', component: ContractAllComponent },
            { path: 'internal-matrix-page', component: InternalMatrixPageComponent },
            { path: 'internal-matrix-edit/:id', component: InternalMatrixEditComponent },

            { path: 'hs-matrix-v2-detail', component: HSMatrixV2DetailComponent },
            { path: 'hs-matrix-v2-detail/:id', component: HSMatrixV2DetailComponent },
            { path: 'hs-matrix-v2-search', component: HSMatrixV2SearchComponent },
            

            { path: 'bc-matrix-v2-detail', component: BCMatrixV2DetailComponent },
            { path: 'bc-matrix-v2-detail/:id', component: BCMatrixV2DetailComponent },
            { path: 'bc-matrix-v2-search', component: BCMatrixV2SearchComponent },

            { path: 'ffm-matrix-v2-detail', component: FFMMatrixV2DetailComponent },
            { path: 'ffm-matrix-v2-detail/:id', component: FFMMatrixV2DetailComponent },
            { path: 'ffm-matrix-v2-search', component: FFMMatrixV2SearchComponent },

      
            { path: 'request-search-v2/:status', component: RequestSearchV2Component }, // request All
            { path: 'request-search-checkin', component: RequestSearchCheckinComponent },
            { path: 'request-search-inprogress', component: RequestSearchInprogressComponent },
            { path: 'request-search-return', component: RequestSearchReturnComponent },
            { path: 'request-search-open', component: RequestSearchOpenComponent },
            { path: 'request-search-waiting-ffm', component: RequestSearchWaitingFFMComponent },
            { path: 'request-search-ffm-approved', component: RequestSearchFFMApprovedComponent },
            { path: 'request-search-finish', component: RequestSearchFinishComponent },
            { path: 'request-search-cancel', component: RequestSearchCancelComponent },
            { path: 'request-search-pendding', component: RequestSearchPenddingComponent },
            { path: 'request-search-all', component: RequestSearchAllComponent },

            { path: 'group-hs-cust-detail', component: GroupHSCustDetailComponent },
            { path: 'group-hs-cust-detail/:id', component: GroupHSCustDetailComponent },
            { path: 'group-hs-cust-search', component: GroupHSCustSearchComponent },
            { path: 'group-hs-member-detail', component: GroupHSMemberDetailComponent },
            { path: 'group-hs-member-detail/:id', component: GroupHSMemberDetailComponent },
            { path: 'group-hs-member-search', component: GroupHSMemberSearchComponent },
            { path: 'hospital-profile-search', component: HospitalProfileSearchComponent },
            { path: 'hospital-profile-detail/:id', component: HospitalProfileDetailComponent },
            { path: 'admin-sql', component: AdminSQLComponent },
        ],
            { onSameUrlNavigation: 'reload' })
    ],
    providers: [
        //{ provide: HelperService, useClass: HelperService },
        //{ provide: AuthenService, useClass: AuthenService },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG },
        //ExcelExportService,
        ToolbarService,
        PageService,
        SortService,
        //FilterService,
        //GroupService,
        FreezeService,
        EditService,
        ForeignKeyService,
        SelectionService,
        CategoryService, LegendService, TooltipService, DataLabelService, LineSeriesService, DateTimeService,
        ScrollBarService, ColumnSeriesService, LineSeriesService, ChartAnnotationService,
        RangeColumnSeriesService, StackingColumnSeriesService, LegendService, TooltipService, BarSeriesService,
        PieSeriesService, AccumulationLegendService, AccumulationTooltipService, AccumulationAnnotationService,
        AccumulationDataLabelService,
        DatePipe,
        ResizeService,
        CheckBoxSelectionService,
        SignalRService
    ],
    bootstrap: [AppComponent]
})

export class AppModule { }

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);



}
